import { DEVICE_TYPE_MOBILE } from '@/common/devicetype.const'
import { PATH_NAME_VOUCHER_POPUP_INFO } from '@/common/router.const'
import utils from '@/common/util/utils'
import router from '@/router'
export function voucherInfoPopup(device) {
  if (device === DEVICE_TYPE_MOBILE) {
    router.push({ name: PATH_NAME_VOUCHER_POPUP_INFO })
  } else {
    location.href = `captvpooq://webview?url=${encodeURIComponent(`https://m.wavve.com/voucher/popup/info?pgname=${utils.getPgName()}`)}&title=${encodeURIComponent('wavve 이용권 소개')}`
  }
}

/**
 *
 * @param {string} date YYYY-MM-DD HH:mm:ss
 * @returns {string} YYYY.MM.DD
 */
export const getDateFormat = (date) => {
  return date.split(' ')[0].replace(/-/g, '.')
}

/**
 * [쿠폰 결제 유예] 정기결제 예정 유저가 이용권 변경 시도시 노출되는 confirm 메시지
 *
 * 이용권 관련 여러 정보를 조합하여 confirm 메시지를 생성한다.
 *
 * requestProductInfo: 이용권 변경 가능 여부 체크 api의 응답 (변경할 이용권 정보)
 *
 * voucher: 변경하려는 이용권 관련 전체 정보 (1개월/장기 이용권 정보 둘 다 포함되어있음)
 *
 * productInfo: voucher 내 선택한 이용권 정보만 추출된 정보
 * @param {object} { requestProductInfo, voucher, productInfo }
 * @returns {string} confirm 메시지
 */
export const confirmChangeUpcomingVoucher = ({
  requestProductInfo,
  voucher,
  productInfo,
}) => {
  const {
    title,
    masterTitleDescription,
    durationStart,
    durationEnd,
    purchaseAmount,
  } = requestProductInfo
  const {
    mobile_support_device: mobileSupportDevice,
    quality,
    concurrency_count: concurrencyCount,
  } = voucher.concurrency[0]
  const { use_day: useDay } = productInfo

  const duration = `${getDateFormat(durationStart)}~${getDateFormat(durationEnd)}`
  const message = `${title}\n${masterTitleDescription}\n${mobileSupportDevice} · ${quality} · ${concurrencyCount}회선\n\n이용기간: ${duration}\n(쿠폰 만료 후 ${useDay})\n\n금액 : ${Number(purchaseAmount).toLocaleString()}원\n\n위 상품으로 이용권을 변경하시겠습니까?`
  return confirm(`${message}`)
}
